import { Component, OnInit } from '@angular/core';
import {FormControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ReqStepperService } from "./req-stepper.service";
import * as backInter from 'app/auth/auth-data.model';
import Swal from 'sweetalert2';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { lang_requerimientos } from 'app/idiomas/i18n/requerimientos/requerimientos.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';

@Component({
  selector: 'app-req-stepper',
  templateUrl: './req-stepper.component.html',
  styleUrls: ['./req-stepper.component.scss']
})
export class ReqStepperComponent implements OnInit {

  cargando = true;
  isLinear = false;
  primerPaso: FormGroup;
  segundoPaso: FormGroup;
  tercerPaso: FormGroup;

  idEmpresa:string;
  datosEmp: backInter.infoEmpresa;
  datosTI: backInter.getITInfo;
  datosPasos: backInter.getInfoReqTec;
  formGroups: FormGroup[] = [];

  porcentajeAvance:number;
  ultimoPaso:number;
  pasoActual = 0;

  listaPasos = [
    "Correo ODS",
    "Configuración RT - Llamada al cliente",
    "Configuración RT - Pruebas",
    "Envío de cuestionario",
    "Fin del cuestionario",
  ];

  fechaHoy = new Date();

  opened:boolean;

  displayedColumns: string[] = ['comentario'];
  idiomaActual:string;

  constructor(
    private _formBuilder: FormBuilder,
    private reqService: ReqStepperService,
    private activatedRoute : ActivatedRoute,
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.idEmpresa = params['id'];
    })
    this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); });
    lang_requerimientos.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.traduceTextosTS();
    this.getDatosSidebar();
    this.getInfoReqTec();
  }

  getDatosSidebar(){
    this.reqService.getInfoEmpresa(this.idEmpresa).subscribe((data:backInter.infoEmpresa) => {
      this.datosEmp = data;
      // console.log(this.datosEmp);
    }, error  => {
      console.log("error");
    });
    this.reqService.getInfoTI(this.idEmpresa).subscribe((respuesta:backInter.getITInfo) => {
      this.datosTI = respuesta;
      // console.log(this.datosTI);
      setTimeout(() => {
        this.opened = true;
      }, 500);
    }, error  => {
      console.log("error");
    });
  }

  getInfoReqTec(){
    this.cargando = true;
    this.reqService.getInfoReqTec(this.idEmpresa).subscribe((respuesta:backInter.getInfoReqTec) => {
      console.log(respuesta);
      this.datosPasos = respuesta;
      this.creaFormGroups();
      this.calculaAvance();
      this.obtieneUltimoPaso();
    });
  }

  calculaAvance(){
    let suma = 0;
    this.datosPasos.pasos.forEach((paso:any, i) => {
      if(paso.status == 2){
        suma++;
      }
    });
    this.porcentajeAvance = ((suma / this.datosPasos.pasos.length) * 100);
  }
  obtieneUltimoPaso(){
    var BreakException = {};
    try {
      this.datosPasos.pasos.forEach((paso:any, i) => {
        if(paso.status == 2){
          this.ultimoPaso = i;
        }
        else{
          throw BreakException;
        }
      });
    } catch (e) {
        if (e !== BreakException) throw e;
    };

  }

  creaFormGroups(){
    // console.log(this.numeroTextosTraduccion);
    this.formGroups = [];
    this.datosPasos.pasos.forEach((paso:any, i) => {
      let group = {};
      group["paso"+i] = new FormControl('',[Validators.required, passwordMatchValidator]);
      group["comentario"+i] = new FormControl('');
      this.formGroups.push(new FormGroup(group));
    });
    console.log(this.formGroups);
    this.cargando = false;
  }

  cambioPosicion(obj:any){
    console.log(obj);
    this.pasoActual = obj.selectedIndex;
  }

  guardaComentario(posicion:number, idPaso:string){
    let texto = this.formGroups[posicion].get('comentario'+posicion).value;
    if(texto != ""){
      // this.mensajeSwal(texto,1);
      this.reqService.updatePaso({comentario:texto},idPaso).subscribe( (data: any) => {
        console.log(data);
        if(data.message == "Success"){
          // this.mensajeSwal("se compelto el paso correctamente",1);
          this.getInfoReqTec();
        }
      });
    }
    else{
      this.mensajeSwal('REQUERIMIENTOS.VALIDACION.MENSAJES.NADA',2);
    }
  }

  completaPaso(idPaso:string, numeroPaso:number){
    if(this.ultimoPaso == (numeroPaso-1)){
      let texto = 'REQUERIMIENTOS.VALIDACION.MENSAJES.COMPLETAR';
      let rspSi = 'REQUERIMIENTOS.VALIDACION.MENSAJES.BOTONES.SI';
      let rspNo = 'REQUERIMIENTOS.VALIDACION.MENSAJES.BOTONES.NO';
      this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
      this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
      this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
      Swal.fire({
        title: texto,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: rspSi,
        cancelButtonText: rspNo
      }).then((result) => {
        if (result.value) {
          this.reqService.updatePaso({status:2},idPaso).subscribe( (data: any) => {
            console.log(data);
            if(data.message == "Success"){
              this.mensajeSwal('REQUERIMIENTOS.VALIDACION.MENSAJES.COMPLETAR_OK',1);
              this.getInfoReqTec();
            }
          });
        }
      });
    }
    else{
      this.mensajeSwal('REQUERIMIENTOS.VALIDACION.MENSAJES.NOCOMPLETAR',2);
    }
  }

  traduceTextosTS(){
    // let iter = 0;
    // for(var k in this.mensajesTraducirTS){
    //   this.translateSrv.get(this.mensajesTraducirKeys[iter]).subscribe((res: string) => {
    //     this.mensajesTraducirTS[k] = res;
    //   });
    //   iter++;
    // }
    this.idiomaActual = this.translateSrv.currentLang;
    // switch(this.translateSrv.currentLang){
    //   case 'es': this.idiomaActual = this.translateSrv.currentLang; break;
    //   default: this.idiomaActual = 'en';
    // }
  }

  mensajeSwal(mensaje:string, tipoMsg:number){
    let texto:string;
    this.translateSrv.get(mensaje).subscribe((res: string) => { texto = res; });
    let tipo: any;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    switch(tipoMsg){
      case 1: tipo = 'success'; break;
      case 2: tipo = 'warning'; break;
      case 3: tipo = 'error'; break;
    }
    Swal.fire({
      title: texto,
      icon: tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });
  }


}
function passwordMatchValidator(control: FormControl) {
  // let valorAct = control.value;
  // if(valorAct != 2)

  return control.value == 2 ? null : {"completo": false};
  // return g.get('password').value === g.get('passwordRepeat').value ? null : {'mismatch': true};
}
